// utils
import request from '../utils/Request'

class ScheduleService {

  async listEspecialidadesAll() {
    const url = `${process.env.REACT_APP_API_MARKETPLACE}/schedule/especialidades-all`
    const result = await request.get(url)
    return result
  }

  async listEspecialidades(context) {
    const url = `${process.env.REACT_APP_API_MARKETPLACE}/schedule/especialidades/${context}`
    const result = await request.get(url)
    return result
  }

  async listEnderecos() {
    const url = `${process.env.REACT_APP_API_MARKETPLACE}/schedule/enderecos`
    const result = await request.get(url)
    return result
  }

  async listPlans() {
    const url = `${process.env.REACT_APP_API_MARKETPLACE}/plan`
    const result = await request.get(url)
    return result
  }

  async getPlan(id) {
    const url = `${process.env.REACT_APP_API_MARKETPLACE}/plan/${id}`
    const result = await request.get(url)
    return result
  }

  async inviteDecode(invite) {
    const url = `${process.env.REACT_APP_API_MARKETPLACE}/plan/invite-decode/${invite}`
    const result = await request.get(url)
    return result
  }

  async search(context, params) {
    const url = `${process.env.REACT_APP_API_MARKETPLACE}/schedule/search/${context}`
    const result = await request.get(url, params)
    return result
  }

  async searchPlantoes(context, params) {
    const url = `${process.env.REACT_APP_API_MARKETPLACE}/schedule/search-plantoes/${context}`
    const result = await request.get(url, params)
    return result
  }

  async getMedico(id, context) {
    const url = `${process.env.REACT_APP_API_MARKETPLACE}/schedule/medico/${id}/${context}`
    const result = await request.get(url)
    return result
  }

  async getMedicoCalendar(id) {
    const url = `${process.env.REACT_APP_API_MARKETPLACE}/schedule/medico/${id}/calendar`
    const result = await request.get(url)
    return result
  }

  async getMedicoRatings(id) {
    const url = `${process.env.REACT_APP_API_MARKETPLACE}/schedule/medico/${id}/rating`
    const result = await request.get(url)
    return result
  }

  async getRating(contextRating) {
    const url = `${process.env.REACT_APP_API_MAIN}/medico/rating-paciente/${contextRating}`
    const result = await request.get(url)
    return result
  }

  async postRating(contextRating, data) {
    const url = `${process.env.REACT_APP_API_MAIN}/medico/rating-paciente/${contextRating}`
    const result = await request.post(url, {}, JSON.stringify(data))
    return result
  }

  async getPlantao(id) {
    const url = `${process.env.REACT_APP_API_MARKETPLACE}/schedule/plantao/${id}`
    const result = await request.get(url)
    return result
  }

  async getPlantaoFila(id, context) {
    const url = `${process.env.REACT_APP_API_MARKETPLACE}/schedule/plantao-fila/${id}/${context}`
    const result = await request.get(url)
    return result
  }

  async putPlantaoFilaCancel(id, context, data) {
    const url = `${process.env.REACT_APP_API_MAIN}/plantao/fila/${id}/cancel/${context}`
    const result = await request.put(url, {}, JSON.stringify(data))
    return result
  }

  async getPlantaoUnicoPrice(context) {
    const url = `${process.env.REACT_APP_API_MAIN}/teleconsulta/plantao-unico/price/${context}`
    const result = await request.get(url)
    return result
  }

  async postPlantaoUnico(data, context) {
    const url = `${process.env.REACT_APP_API_MAIN}/teleconsulta/plantao-unico/${context}`
    const result = await request.post(url, {}, JSON.stringify(data))
    return result
  }

  async getAtendimento(id, idIsHash, context) {
    const url = context
      ? `${process.env.REACT_APP_API_MAIN}/teleconsulta/${id}/${context}`
      : `${process.env.REACT_APP_API_MAIN}/teleconsulta/${idIsHash ? 'hash/' : ''}${id}`
    const result = await request.get(url)
    return result
  }

  async postAtendimento(idPaciente, data, context, gaClientId) {
    let url = `${process.env.REACT_APP_API_MAIN}/paciente/${idPaciente}/atendimento/${context}`
    if (gaClientId) url += `?ga_cid=${gaClientId}`
    const result = await request.post(url, {}, JSON.stringify(data))
    return result
  }

  async putJoinQueue(idPlantao, context, data) {
    const url = `${process.env.REACT_APP_API_MAIN}/plantao/${idPlantao}/entrar-fila/${context}`
    const result = await request.put(url, {}, JSON.stringify(data))
    return result
  }

  async putAtendimentoReschedule(data, context = null) {
    const url = `${process.env.REACT_APP_API_MAIN}/paciente/agendamento/reschedule${context ? `/${context}` : ''}`
    const result = await request.put(url, {}, JSON.stringify(data))
    return result
  }

  async putAtendimentoReturn(data) {
    const url = `${process.env.REACT_APP_API_MAIN}/paciente/agendamento/retorno`
    const result = await request.put(url, {}, JSON.stringify(data))
    return result
  }

  async putAtendimentoCancel(data) {
    const url = `${process.env.REACT_APP_API_MAIN}/paciente/agendamento/cancel`
    const result = await request.put(url, {}, JSON.stringify(data))
    return result
  }

  /**
   * @deprecated
   */
  async getPayUrl(id) {
    const url = `${process.env.REACT_APP_API_MAIN}/pagamento/approval-url/teleconsulta/${id}`
    const result = await request.get(url)
    return result
  }

  /**
   * @deprecated
   */
  async getExecutePay(id, payerId) {
    const url = `${process.env.REACT_APP_API_MAIN}/pagamento/execute/teleconsulta/${id}/${payerId}`
    const result = await request.get(url)
    return result
  }

  /**
   * Solicita chave de encriptação para utilização no checkout.
   */
   async getPagarmeEncryptionKey(context) {
    const url = `${process.env.REACT_APP_API_MAIN}/pagamento/pagarme-encryption-key/${context}`
    const result = await request.get(url)
    return result
  }

   /**
    * Gera transação via PIX.
    *
    * @param {String} entity
    * @param {Number} idEntity
    * @param {String} context
    */
    async getPagarmePixTransaction(entity, idEntity, context) {
      const url = `${process.env.REACT_APP_API_MAIN}/pagamento/pagarme-pix-transaction/${entity}/${idEntity}/${context}`
      const result = await request.get(url)
      return result
    }

  /**
   * Solicita captura de valor de transação realizada pelo checkout do pagarme.
   *
   * @param {String} entity
   * @param {Number} idEntity
   * @param {String} transactionId
   */
  async getPagarmeCaptureTransaction(entity, idEntity, transactionToken) {
    const url = `${process.env.REACT_APP_API_MAIN}/pagamento/pagarme-capture-transaction/${entity}/${idEntity}/${transactionToken}`
    const result = await request.get(url)
    return result
  }

  /**
   * @deprecated
   */
  async putRememberCard(id, token) {
    const url = `${process.env.REACT_APP_API_MAIN}/pagamento/remember-card/user_paciente/${id}`
    const result = await request.put(url, {}, JSON.stringify({ token }))
    return result
  }

  /**
   * @deprecated
   */
  async deletePayUrl(id) {
    const url = `${process.env.REACT_APP_API_MAIN}/pagamento/approval-url/teleconsulta/${id}`
    const result = await request.delete(url)
    return result
  }

  async getSaveComprovantePagamento(id, uploadTmpUuid) {
    const url = `${process.env.REACT_APP_API_MAIN}/pagamento/comprovante/${id}?uploadTmpUuid=${uploadTmpUuid}`
    const result = await request.get(url)
    return result
  }

  async getCallLink(id) {
    const url = `${process.env.REACT_APP_API_MAIN}/teleconsulta/${id}/call/link-paciente`
    const result = await request.get(url)
    return result
  }

  async getMedicalRecords() {
    const url = `${process.env.REACT_APP_API_MAIN}/paciente/null/prontuario`
    const result = await request.get(url)
    return result
  }

  async putInvoiceRequest(idTeleconsulta) {
    const url = `${process.env.REACT_APP_API_MAIN}/teleconsulta/${idTeleconsulta}/solicitar-nota-medica`
    const result = await request.put(url)
    return result
  }

  async postConfirmPresence(idTeleconsulta) {
    const url = `${process.env.REACT_APP_API_MAIN}/teleconsulta/${idTeleconsulta}/confirm-presence`
    const result = await request.post(url)
    return result
  }

  async getCabins(context) {
    const url = `${process.env.REACT_APP_API_MAIN}/cabine/all/${context}`
    const result = await request.get(url)
    return result
  }

  async getCabin(id, context) {
    const url = `${process.env.REACT_APP_API_MAIN}/cabine/${id}/${context}`
    const result = await request.get(url)
    return result
  }

}

export default new ScheduleService()
